import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillPlusCircle } from "react-icons/ai";
import { jsPDF } from "jspdf";
import axios from "axios";
import Swal from "sweetalert2";
import useAuthUser from "../../auth/getUser";
import html2canvas from "html2canvas";
const Payment = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  const { user } = useAuthUser();

  const handleDownload = () => {
    const pdf = new jsPDF("portrait", "pt", "a4");

    html2canvas(document.querySelector("#report")).then((canvas) => {
      const img = canvas.toDataURL("image/png");
      const imgProperties = pdf.getImageProperties(img);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
      pdf.addImage(img, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("shipping_label.pdf");
    });
  };
  const [items, setItems] = useState([
    {
      description: "",
      rate: 0,
      hours: 0,
      amount: 0,
    },
  ]);

  const handleChangeItems = (idx, field, value) => {
    setItems(
      items.map((item, index) => {
        if (index !== idx) return item;

        return {
          ...item,
          [field]: value,
        };
      })
    );
  };

  const handleAddItem = () => {
    const newItem = {
      description: "",
      rate: "",
      hours: "",
      amount: "",
    };
    setItems((prevItems) => [...prevItems, newItem]);
  };

  const handleDeleteTemplate = async () => {
    setValue("fullName", "");
    setValue("email", "");
    setValue("payment_option", "");
    setValue("currency", "");
    setValue("invoiceNumber", "");
    setValue("invoiceDate", "");
    setValue("dueDate", "");
    setValue("billTo", "");
    setValue("employer_name", "");
    setValue("company_name", "");
    setValue("notes", "");
    setValue("totalAmount", "");
    setItems([
      {
        description: "",
        rate: 0,
        hours: 0,
        amount: 0,
      },
    ]);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_API}/payment/update-template/${user?._id}?isReset=true`
      );
      console.log(response);

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Template deleted successful",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error creatingpayment:", error?.message);
    }
  };

  const handleSendInvoice = async () => {
    const values = getValues(); // Get all form values

    // Check if all required values are present
    const {
      fullName,
      email,
      payment_option,
      currency,
      invoiceNumber,
      invoiceDate,
      dueDate,
      billTo,
      employer_name,
      company_name,
      notes,
      totalAmount,
    } = values;

    if (
      !fullName ||
      !email ||
      !payment_option ||
      !currency ||
      !invoiceNumber ||
      !invoiceDate ||
      !dueDate ||
      !billTo ||
      !employer_name ||
      !company_name ||
      !notes ||
      !totalAmount ||
      items.some(
        (item) =>
          !item.description ||
          item.rate === 0 ||
          item.hours === 0 ||
          item.amount === 0
      )
    ) {
      alert("please fill up all the required fields");
      return;
    }

    const invoiceData = {
      userId: user?._id,
      ...values,
      items,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API}/payment/send-invoice`,
        invoiceData
      );
      console.log(response);
      if (response.data.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Invoice sent successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("Error sending invoice:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error sending invoice",
        showConfirmButton: true,
      });
    }
  };

  const onSubmit = async (data) => {
    console.log(data);

    const payment = {
      userId: user?._id,
      ...data,
      items,
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_API}/payment/update-template/${user?._id}`,
        payment
      );
      console.log(response);
      if (response.data) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "Payment saved successful",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("Error creatingpayment:", error);
    }
  };

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API}/payment/${user?._id}`
        );
        const paymentData = response.data;
        console.log(paymentData);

        // Set the form values
        setValue("fullName", paymentData.fullName);
        setValue("email", paymentData.email);
        setValue("payment_option", paymentData.payment_option);
        setValue("currency", paymentData?.currency);
        setValue("invoiceNumber", paymentData.invoiceNumber);
        setValue("invoiceDate", paymentData.invoiceDate.split("T")[0]); // Set date properly
        setValue("dueDate", paymentData.dueDate.split("T")[0]); // Set date properly
        setValue("billTo", paymentData.billTo);
        setValue("employer_name", paymentData.employer_name);
        setValue("company_name", paymentData.company_name);
        setValue("notes", paymentData.notes);
        setValue("totalAmount", paymentData.totalAmount);
        setItems(paymentData.items);
      } catch (error) {
        console.error("Error fetching payment data:", error);
      }
    };

    if (user?._id) {
      fetchPaymentData();
    }
  }, [user, setValue]);

  return (
    <div className="max-w-6xl mx-auto">
      <form onSubmit={handleSubmit(onSubmit)} id="report" className="card-body">
        {/* Your form fields */}
        <div className="grid gap-2 md:grid-cols-2">
          {/* Name and Email */}
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Full Name</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("fullName", {
                required: true,
              })}
            />
            {errors.fullName && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Email</span>
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              className="input input-sm input-bordered rounded-2xl"
              {...register("email", {
                required: true,
              })}
            />
            {errors.email && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        {/* Other form fields */}
        <div className="grid gap-2 md:grid-cols-2">
          {/* Payment Option and Currency */}
          <div className="mt-3 form-control">
            <label>Payment Option</label>
            <select
              {...register("payment_option")}
              className="p-1 rounded-xl bg-base-100"
            >
              <option value="part time">1</option>
              <option value="full time">2</option>
              <option value="hybridge">3</option>
            </select>
            {errors.payment_option && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="mt-3 form-control">
            <label>Currency</label>
            <select
              {...register("currency", {
                required: true,
              })}
              className="p-1 rounded-xl bg-base-100"
            >
              <option value="40">40</option>
              <option value="25">25</option>
              <option value="30">30</option>
            </select>
            {errors.currency && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        {/* Invoice and Billing Information */}
        <div className="grid gap-2 md:grid-cols-3">
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Invoice No</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("invoiceNumber", {
                required: true,
              })}
            />
            {errors.invoiceNumber && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Invoice Date</span>
            </label>
            <input
              type="date"
              className="input input-sm input-bordered rounded-2xl"
              {...register("invoiceDate", {
                required: true,
              })}
            />
            {errors.invoiceDate && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Due Date</span>
            </label>
            <input
              type="date"
              className="input input-sm input-bordered rounded-2xl"
              {...register("dueDate", {
                required: true,
              })}
            />
            {errors.dueDate && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        {/* More Billing Information */}
        <div className="grid gap-2 md:grid-cols-3">
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Bill To</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("billTo", {
                required: true,
              })}
            />
            {errors.billTo && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Employer Name</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("employer_name", {
                required: true,
              })}
            />
            {errors.employer_name && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Company Name</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("company_name", {
                required: true,
              })}
            />
            {errors.company_name && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        {/* Itemized Billing Information */}
        {items?.map((item, idx) => (
          <div
            className={`grid gap-2 px-2 pt-5 pb-5 bg-slate-300 md:grid-cols-4 rounded-xl ${
              idx > 0 ? "mt-3" : ""
            }`}
          >
            <div className="form-control">
              <label className="label">
                <span className="font-semibold">Description</span>
              </label>
              <input
                type="text"
                className="input input-sm input-bordered rounded-2xl"
                value={item.description}
                onChange={(e) =>
                  handleChangeItems(idx, "description", e.target.value)
                }
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="font-semibold">Rate</span>
              </label>
              <input
                type="number"
                className="input input-sm input-bordered rounded-2xl"
                value={item.rate}
                onChange={(e) => handleChangeItems(idx, "rate", e.target.value)}
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="font-semibold">Hour</span>
              </label>
              <input
                type="number"
                className="input input-sm input-bordered rounded-2xl"
                value={item.hours}
                onChange={(e) =>
                  handleChangeItems(idx, "hours", e.target.value)
                }
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="font-semibold">Amount</span>
              </label>
              <input
                type="number"
                className="input input-sm input-bordered rounded-2xl"
                value={item.amount}
                onChange={(e) =>
                  handleChangeItems(idx, "amount", e.target.value)
                }
              />
            </div>
          </div>
        ))}

        {/* Add Another Line Item */}
        <div className="mt-3 cursor-pointer" onClick={handleAddItem}>
          <h1 className="flex gap-2">
            <AiFillPlusCircle className="text-2xl text-green-600" />
            Add another line item
          </h1>
        </div>

        {/* Notes and Total Amount */}
        <div className="grid gap-2 md:grid-cols-2">
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Notes to participant</span>
            </label>
            <input
              type="text"
              className="input input-sm input-bordered rounded-2xl"
              {...register("notes", {
                required: true,
              })}
            />
            {errors.notes && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="form-control">
            <label className="label">
              <span className="font-semibold">Total amount</span>
            </label>
            <input
              type="number"
              className="input input-sm input-bordered rounded-2xl"
              {...register("totalAmount", {
                required: true,
              })}
            />
            {errors.totalAmount && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        {/* Stripe Elements and CheckoutForm */}

        {/* <div type="submit" className="p-5 mt-3">
          <Payment2 />
        </div> */}

        {/* Buttons */}
        <div className="flex items-center justify-between gap-2">
          <button
            className="mt-3 btn btn-success !text-white"
            // onClick={handleDownload}
            type="button"
          >
            Download PDF
          </button>
          <button className="mt-3 btn btn-success !text-white" type="submit">
            Save as Template
          </button>
          <button
            onClick={handleDeleteTemplate}
            className="mt-3 btn btn-outline btn-error"
            type="button"
          >
            Delete Template
          </button>
          <button
            className="mt-3 btn btn-warning"
            type="button"
            onClick={handleSendInvoice}
          >
            Send Invoice
          </button>
        </div>
      </form>
    </div>
  );
};

export default Payment;
